export class CenterCommission {
    constructor() {
        this.center = document.getElementById("center");
        this.centerPriceWrapper = document.querySelectorAll(".js-center-price-wrapper");
        if (this.centerPriceWrapper.length === 0) {
            return;
        }
        if (this.center === null) {
            return;
        }
        $("#center").on("change", () => this.onCenterChanged());
        this.onCenterChanged();
    }
    onCenterChanged() {
        this.centerPriceWrapper.forEach((wrapper) => {
            const commissionPercentage = parseFloat(this.center.options[this.center.selectedIndex].dataset["commission"]);
            const centerPrice = wrapper.querySelector(".js-center-price");
            centerPrice.dataset["commission"] = commissionPercentage.toString();
            centerPrice.dispatchEvent(new Event("commission-changed"));
            if (commissionPercentage === 0.0) {
                wrapper.classList.add("hidden");
            }
            else {
                wrapper.classList.remove("hidden");
            }
        });
    }
}
